module.exports = __webpack_public_path__ + "static/media/chrome-pwa.9616184e.svg";